import React from 'react';
import { Store, Save } from 'lucide-react';

const BasicInfo = ({ settings, onSettingsChange, onSave, isSaving }) => {
  const handleSaveClick = () => {
    onSave(`매장명을 "${settings.storeName}"(으)로 변경하시겠습니까?`, { storeName: settings.storeName });
  };

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-3 border-b">
        <h3 className="text-lg font-semibold flex items-center">
          <Store className="w-5 h-5 mr-2 text-gray-600" />
          기본 정보
        </h3>
      </div>

      <div className="p-3 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              매장명
            </label>
            {/* 좁은 화면에서는 input의 flex 기본 min-width 때문에
                저장 버튼이 밀려서 잘려 보이는 문제가 있었다 - 세로로
                쌓이게 바꿔서 아예 좁아질 일이 없게 함. */}
            <div className="flex flex-col sm:flex-row gap-2">
              <input
                type="text"
                value={settings.storeName}
                onChange={(e) => onSettingsChange('storeName', e.target.value)}
                className="flex-1 min-w-0 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                placeholder="매장명을 입력하세요"
              />
              <button
                type="button"
                onClick={handleSaveClick}
                disabled={isSaving || !settings.storeName}
                className="w-full sm:w-auto flex items-center justify-center gap-1 px-4 py-2 bg-blue-500 text-white text-sm rounded-lg hover:bg-blue-600 disabled:opacity-50 transition-colors whitespace-nowrap"
              >
                <Save className="w-4 h-4" />
                저장
              </button>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              매장 코드
            </label>
            <input 
              type="text" 
              value={settings.storeCode}
              className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 cursor-not-allowed"
              disabled
            />
            <p className="text-xs text-gray-500 mt-1">매장 코드는 변경할 수 없습니다.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;